module.exports = __webpack_public_path__ + "img/出库列表.da7c56e1.svg";